import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { IPagination } from '../../interfaces/pagination.interface';

@Component({
  selector: 'app-table-pagination',
  templateUrl: './table-pagination.component.html',
  styleUrls: ['./table-pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TablePaginationComponent {
  @Input() filters!: FormGroup;
  @Input() pagination!: BehaviorSubject<IPagination<any>>;

  get canNext(): boolean {
    if (this.pagination.value.total > this.filters.value.skip + this.filters.value.take) {
      return true;
    }
    return false;
  }

  get canPrevious(): boolean {
    if (this.filters.value.skip - this.filters.value.take >= 0) {
      return true;
    }
    return false;
  }

  public nextPage(): void {
    if (this.canNext) {
      this.filters.patchValue({ skip: this.filters.value.skip + this.filters.value.take });
    }
  }

  public previousPage(): void {
    if (this.canPrevious) {
      this.filters.patchValue({ skip: this.filters.value.skip - this.filters.value.take });
    }
  }
}
